import { v2 } from './api.js'
import qs from 'qs'

export default {
  getOpportunities: async (params = {}) => {
    return (await v2.get('/me/opportunities', {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    })).data
  },

  getAccounts: async (params = {}) => {
    return (await v2.get('/me/accounts', {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    })).data
  },

  getSupportCases: async (params = {}) => {
    return (await v2.get('me/se-support-cases', {
      params, 
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    })).data
  },

  getTeam: async() => {
    return (await v2.get('/me/team')).data
  },

  getAllOpportunitiesMyAccounts: async () => {
    let result
    try {
      result = (await v2.get('/me/accounts/all-opportunities')).data
    } catch (error) {
      return error
    }
    return result
  },

  getUserSettingsById: async (id) => {
    return (await v2.get(`/user/${id}/settings`)).data
  },

  getProductAdoptions: async (params = {}) => {
    let result
    let paramsObj = {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    }

    try {
      result = (await v2.get('/me/product-adoptions', paramsObj)).data.filter(pa => {
        return [
          '10 - Implementation',
          '11 - Consumption',
          '12 - Effective Adoption',
          '13 - No Longer in Use',
          '14 - Ready to Renew',
          '15 - Unvalidated'
        ].includes(pa.productStage)
      })
    } catch (error) {
      return error
    }
    return result
  },

  getProductAdoptionsById: async (id) => {
    return (await v2.get(`/user/${id}/product-adoptions`)).data.filter(pa => {
      return [
        '10 - Implementation',
        '11 - Consumption',
        '12 - Effective Adoption',
        '14 - Ready to Renew'
      ].includes(pa.productStage)
    })
  }
}
